import React from 'react';
import { Icon } from '../Icon/Icon';

export interface ReceptionistSettingsSaveBarProps {
  isDirty: boolean;
  changeCount: number;
  onSave: () => void;
  onDiscard: () => void;
}

export function ReceptionistSettingsSaveBar({
  isDirty,
  changeCount,
  onSave,
  onDiscard,
}: ReceptionistSettingsSaveBarProps) {
  if (!isDirty) return null;

  return (
    <div
      className="set-savebar fixed bottom-0 right-0 z-30 flex items-center gap-3 border-t border-[var(--cream-2)] bg-[var(--cream-1)] px-8 py-3.5 shadow-[0_-8px_28px_rgba(28,24,18,0.10),0_-2px_6px_rgba(28,24,18,0.06)]"
      style={{ left: 244 }}
    >
      <div className="flex items-center gap-2.5">
        <span className="h-2 w-2 rounded-[999px]" style={{ background: 'var(--set-green)' }} />
        <div>
          <div className="text-[13px] font-semibold tracking-[-0.005em] text-[var(--ink-0)]">
            You have unsaved changes
          </div>
          <div className="mt-px text-[11.5px] font-medium text-[var(--ink-2)]">
            {changeCount} {changeCount === 1 ? 'field' : 'fields'} updated · will apply to live calls on save
          </div>
        </div>
      </div>
      <div className="ml-auto flex gap-2">
        <button type="button" className="set-btn" onClick={onDiscard}>
          Discard
        </button>
        <button type="button" className="set-btn-primary" onClick={onSave}>
          <Icon kind="check-circ" size={13} stroke={2} />
          Save changes
        </button>
      </div>
    </div>
  );
}
